<div class="{{tenantCode}}-theme p-4 w-100">
    <h1>Hey! Are you still there?</h1>
    <p>Your security is important to us. If you do not respond within 10 minutes you will be automatically logged
        out.</p>
    <div class="d-flex action-row justify-content-end w-100 mt-3">
        <app-button class="float-right" title="Keep me logged in" icon="check" (onClick)="stillThere()"></app-button>
        <app-button class="float-right" title="Logout" icon="logout" (onClick)="logout()"></app-button>
    </div>
</div>